export default function BrickBreakerIcon() {
  const rows = ['#ff3b5c', '#ff9c3b', '#ffe14d', '#8dff4a'];
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#14062c" />
      {rows.map((c, r) =>
        [0, 1, 2, 3].map((i) => (r === 3 && i === 2 ? null : <rect key={`${r}-${i}`} x={7 + i * 13} y={8 + r * 7} width="11" height="5.5" rx="1.5" fill={c} />)),
      )}
      <circle cx="38" cy="44" r="4" fill="#fff" />
      <path d="M30 37l-4-5" stroke="#38f8ff" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
      <path d="M19 52h22l3 6H16z" fill="#38f8ff" />
      <rect x="22" y="53.5" width="16" height="1.6" fill="#fff" />
    </svg>
  );
}
